import { Icon, IconProps } from '@joinrepublic/dls-ui-kit';

export const GooglePlayStoreLogoOnlyIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 18 22"
    width="18px"
    height="22px"
    fill="currentColor"
    {...props}
  >
    <path
      d="M1.65511 0.861679L10.7417 10.1198L13.0865 7.73034C9.88248 5.74932 5.59119 3.0918 3.66125 1.89695L2.36829 1.09871C2.13975 0.956826 1.89504 0.880418 1.65511 0.861679ZM0.268092 1.97015C0.249703 2.07187 0.233887 2.1741 0.233887 2.28386V20.5806C0.233887 20.6573 0.249033 20.7287 0.259541 20.8019L9.5035 11.3817L0.268092 1.97015ZM14.6274 8.68369L11.98 11.3817L14.5813 14.0326C15.9595 13.1813 16.9141 12.5901 17.0201 12.525C17.4886 12.2332 17.7531 11.7929 17.7452 11.3119C17.7382 10.8399 17.4736 10.4178 17.0235 10.1582C16.9228 10.0993 15.9812 9.51983 14.6274 8.68369ZM10.7417 12.6435L1.68248 21.8755C1.85848 21.8443 2.03427 21.7908 2.2024 21.6873C2.43532 21.5427 8.72772 17.6523 13.0403 14.9859L10.7417 12.6435Z"
      fill="currentColor"
    />
  </Icon>
);
